import gql from 'graphql-tag'
import { projectSummaryFragment } from "@/graphql/project/projectFragments";
import { tagFragment, customTagFragment, customTagLabelFragment } from '@/graphql/tag/tagFragments'
// import { userProfileFragment } from "@/graphql/user/userProfileFragments";
// import { customerFragment } from '@/graphql/customer/customerFragments'
// import { customerContactFragment } from '@/graphql/customer/customerContactFragments'
// import { customerLocationFragment } from '@/graphql/customer/customerLocationFragments'
import { projectShiftFragment, shiftFragment, draftShiftFragment } from "@/graphql/shift/shiftFragments";
import { projectAssignmentFragment, assignmentFragment, draftAssignmentFragment } from "@/graphql/assignment/assignmentFragments";
import { resourceFragment, resourceTypeFragment, staffVehiculeFragment } from "@/graphql/resource/resourceFragments";
import { categoryFragment } from "@/graphql/category/categoryFragments";

export const REBUILDPROJECTSINDEX = gql`
    mutation rebuildProjectsIndex{
        rebuildProjectsIndex{
            id
            name
        }
    }
`

export const UPDATEPROJECTINTERNALNOTES = gql`
    mutation updateProjectInternalNotes(
        $projectID: ID!
        $internalNote: String
    ){
        updateProjectInternalNotes(
            id: $projectID
            internal_notes: $internalNote
        ){
            id
            internal_notes
        }
    }

`

export const ARCHIVEPROJECT = gql`
    mutation archiveProject(
        $projectID: ID!
        $shiftsDateRange: activeDuringInputSingleDate!
    ){
        archiveProject(
            projectID: $projectID
        )
        {
            ...projectSummaryFragment
            prevShift(
                dateRange: $shiftsDateRange
            )
            nextShift(
                dateRange: $shiftsDateRange
            )

            professions{
                ...tagFragment
            }
            skills{
                ...tagFragment
            }
            courses{
                ...tagFragment
            }
            customtags{
                ...customTagFragment
                label{
                    ...customTagLabelFragment
                }
            }
            resources{
                ...resourceFragment
                type{
                    ...resourceTypeFragment
                }
            }

            projectManager{
                # ...userProfileFragment
                id
                name
                email
            }
            supervisor{
                # ...userProfileFragment
                id
                name
                email
            }
            customers{
                # ...customerFragment
                id
                name
            }
            projectCategories{
                ...categoryFragment
            }
            contacts {
                # ...customerContactFragment
                id
                name
                email
            }
            locations {
                # ...customerLocationFragment
                id
                name
            }

            projectShifts {
                ...projectShiftFragment
                courses{
                    ...tagFragment
                }
                skills{
                    ...tagFragment
                }
                customtags{
                    ...customTagFragment
                    label{
                        ...customTagLabelFragment
                    }
                }
                resources{
                    ...resourceFragment
                    type{
                        ...resourceTypeFragment
                    }
                }
                staffVehicules{
                    ...staffVehiculeFragment
                    type{
                        ...resourceTypeFragment
                    }
                }

                projectAssignments{
                    ...projectAssignmentFragment
                    assignedTo{
                        # ...userProfileFragment
                        id
                        name
                        email
                    }
                    profession{
                        ...tagFragment
                    }
                }
            }

            shifts(
                dateRange: $shiftsDateRange
            ) {
                ...shiftFragment

                assignments {
                    ...assignmentFragment
                    assignedTo {
                        # ...userProfileFragment
                        id
                        name
                        email
                    }
                    accepted_by {
                        # ...userProfileFragment
                        id
                        name
                        email
                    }
                    profession{
                        ...tagFragment
                    }
                }
            }

            draftShifts(
                dateRange: $shiftsDateRange
            ) {
                ...draftShiftFragment

                assignments {
                    ...draftAssignmentFragment
                    assignedTo {
                        # ...userProfileFragment
                        id
                        name
                        email
                    }
                    profession{
                        ...tagFragment
                    }
                }
            }


            created_by {
                # ...userProfileFragment
                id
                name
                email
            }
        }
    }
    ${projectSummaryFragment}
    ${tagFragment}
    ${customTagFragment}
    ${customTagLabelFragment}
    ${projectShiftFragment}
    ${shiftFragment}
    ${draftShiftFragment}
    ${projectAssignmentFragment}
    ${assignmentFragment}
    ${draftAssignmentFragment}
    ${resourceFragment}
    ${staffVehiculeFragment}
    ${resourceTypeFragment}
    ${categoryFragment}
`
    // ${userProfileFragment}
    // ${customerFragment}
    // ${customerContactFragment}
    // ${customerLocationFragment}


export const DELETEPROJECT = gql`
    mutation deleteProject(
        $projectID: ID!
        $shiftsDateRange: activeDuringInputSingleDate!
    ){
        deleteProject(
            projectID: $projectID
        )
        {
            ...projectSummaryFragment
        }
    }
    ${projectSummaryFragment}
`


export const CREATEDRAFTSHIFTS = gql`
    mutation createDraftShifts(
        $projectID: ID!
        $shiftsDateRange: activeDuringInputSingleDate!
    ){
        createDraftShifts(
            projectID: $projectID
        ){
            ...projectSummaryFragment
            hasUnpublishedShift
            
            prevShift(
                dateRange: $shiftsDateRange
            )
            nextShift(
                dateRange: $shiftsDateRange
            )

            professions{
                ...tagFragment
            }
            skills{
                ...tagFragment
            }
            courses{
                ...tagFragment
            }
            customtags{
                ...customTagFragment
                label{
                    ...customTagLabelFragment
                }
            }
            resources{
                ...resourceFragment
                type{
                    ...resourceTypeFragment
                }
            }

            projectManager{
                # ...userProfileFragment
                id
                name
                email
            }
            supervisor{
                # ...userProfileFragment
                id
                name
                email
            }
            customers{
                # ...customerFragment
                id
                name
            }
            projectCategories{
                ...categoryFragment
            }
            contacts {
                # ...customerContactFragment
                id
                name
                email
            }
            locations {
                # ...customerLocationFragment
                id
                name
            }

            projectShifts {
                ...projectShiftFragment
                courses{
                    ...tagFragment
                }
                skills{
                    ...tagFragment
                }
                customtags{
                    ...customTagFragment
                    label{
                        ...customTagLabelFragment
                    }
                }
                resources{
                    ...resourceFragment
                    type{
                        ...resourceTypeFragment
                    }
                }
                staffVehicules{
                    ...staffVehiculeFragment
                    type{
                        ...resourceTypeFragment
                    }
                }

                projectAssignments{
                    ...projectAssignmentFragment
                    assignedTo{
                        # ...userProfileFragment
                        id
                        name
                        email
                    }
                    profession{
                        ...tagFragment
                    }
                }
            }

            shifts(
                dateRange: $shiftsDateRange
            ) {
                ...shiftFragment

                assignments {
                    ...assignmentFragment
                    assignedTo {
                        # ...userProfileFragment
                        id
                        name
                        email
                    }
                    accepted_by {
                        # ...userProfileFragment
                        id
                        name
                        email
                    }
                    profession{
                        ...tagFragment
                    }
                }
            }

            draftShifts(
                dateRange: $shiftsDateRange
            ) {
                ...draftShiftFragment

                assignments {
                    ...draftAssignmentFragment
                    assignedTo {
                        # ...userProfileFragment
                        id
                        name
                        email
                    }
                    profession{
                        ...tagFragment
                    }
                }
            }


            created_by {
                # ...userProfileFragment
                id
                name
                email
            }
        }
    }
    ${projectSummaryFragment}
    ${tagFragment}
    ${customTagFragment}
    ${customTagLabelFragment}
    ${projectShiftFragment}
    ${shiftFragment}
    ${draftShiftFragment}
    ${projectAssignmentFragment}
    ${assignmentFragment}
    ${draftAssignmentFragment}
    ${resourceFragment}
    ${staffVehiculeFragment}
    ${resourceTypeFragment}
    ${categoryFragment}
`
    // ${userProfileFragment}
    // ${customerFragment}
    // ${customerContactFragment}
    // ${customerLocationFragment}

export const PUBLISHSHIFTS = gql`
    mutation publishShifts(
        $projectID: ID!
        $shiftsDateRange: activeDuringInputSingleDate!
    ){
        publishShifts(
            projectID: $projectID
        ){
            ...projectSummaryFragment
            hasUnpublishedShift

            prevShift(
                dateRange: $shiftsDateRange
            )
            nextShift(
                dateRange: $shiftsDateRange
            )

            professions{
                ...tagFragment
            }
            skills{
                ...tagFragment
            }
            courses{
                ...tagFragment
            }
            customtags{
                ...customTagFragment
                label{
                    ...customTagLabelFragment
                }
            }
            resources{
                ...resourceFragment
                type{
                    ...resourceTypeFragment
                }
            }

            projectManager{
                    # ...userProfileFragment
                    id
                    name
                    email
            }
            supervisor{
                    # ...userProfileFragment
                    id
                    name
                    email
            }
            customers{
                    # ...customerFragment
                    id
                    name
            }
            projectCategories{
                ...categoryFragment
            }
            contacts {
                    # ...customerContactFragment
                    id
                    name
                    email
            }
            locations {
                    # ...customerLocationFragment
                    id
                    name
            }

            projectShifts {
                ...projectShiftFragment
                courses{
                    ...tagFragment
                }
                skills{
                    ...tagFragment
                }
                customtags{
                    ...customTagFragment
                    label{
                        ...customTagLabelFragment
                    }
                }
                resources{
                    ...resourceFragment
                    type{
                        ...resourceTypeFragment
                    }
                }
                staffVehicules{
                    ...staffVehiculeFragment
                    type{
                        ...resourceTypeFragment
                    }
                }


                projectAssignments{
                    ...projectAssignmentFragment
                    assignedTo{
                        # ...userProfileFragment
                        id
                        name
                        email
                    }
                    profession{
                        ...tagFragment
                    }
                }
            }

            shifts(
                dateRange: $shiftsDateRange
            ) {
                ...shiftFragment

                assignments {
                    ...assignmentFragment
                    assignedTo {
                        # ...userProfileFragment
                        id
                        name
                        email
                    }
                    accepted_by {
                        # ...userProfileFragment
                        id
                        name
                        email
                    }
                    profession{
                        ...tagFragment
                    }
                }
            }

            draftShifts(
                dateRange: $shiftsDateRange
            ) {
                ...draftShiftFragment

                assignments {
                    ...draftAssignmentFragment
                    assignedTo {
                        # ...userProfileFragment
                        id
                        name
                        email
                    }
                    profession{
                        ...tagFragment
                    }
                }
            }


            created_by {
                # ...userProfileFragment
                id
                name
                email
            }
        }
    }
    ${projectSummaryFragment}
    ${tagFragment}
    ${customTagFragment}
    ${customTagLabelFragment}
    ${projectShiftFragment}
    ${shiftFragment}
    ${draftShiftFragment}
    ${projectAssignmentFragment}
    ${assignmentFragment}
    ${draftAssignmentFragment}
    ${resourceFragment}
    ${staffVehiculeFragment}
    ${resourceTypeFragment}
    ${categoryFragment}
`
    // ${customerFragment}
    // ${customerContactFragment}
    // ${customerLocationFragment}
    // ${userProfileFragment}

export const SENDPROJECTNOTIFICATIONS = gql`
    mutation sendProjectNotifications(
        $projectID: ID!
        $shiftsDateRange: activeDuringInputSingleDate!
    ){
        sendProjectNotifications(
            projectID: $projectID
        ){
            ...projectSummaryFragment
            prevShift(
                dateRange: $shiftsDateRange
            )
            nextShift(
                dateRange: $shiftsDateRange
            )

            professions{
                ...tagFragment
            }
            skills{
                ...tagFragment
            }
            courses{
                ...tagFragment
            }
            customtags{
                ...customTagFragment
                label{
                    ...customTagLabelFragment
                }
            }
            resources{
                ...resourceFragment
                type{
                    ...resourceTypeFragment
                }
            }

            projectManager{
                # ...userProfileFragment
                id
                name
                email
            }
            supervisor{
                # ...userProfileFragment
                id
                name
                email
            }
            customers{
                # ...customerFragment
                id
                name
            }
            projectCategories{
                ...categoryFragment
            }
            contacts {
                # ...customerContactFragment
                id
                name
                email
            }
            locations {
                # ...customerLocationFragment
                id
                name
            }

            projectShifts {
                ...projectShiftFragment
                courses{
                    ...tagFragment
                }
                skills{
                    ...tagFragment
                }
                customtags{
                    ...customTagFragment
                    label{
                        ...customTagLabelFragment
                    }
                }
                resources{
                    ...resourceFragment
                    type{
                        ...resourceTypeFragment
                    }
                }
                staffVehicules{
                    ...staffVehiculeFragment
                    type{
                        ...resourceTypeFragment
                    }
                }


                projectAssignments{
                    ...projectAssignmentFragment
                    assignedTo{
                        # ...userProfileFragment
                        id
                        name
                        email
                    }
                    profession{
                        ...tagFragment
                    }
                }
            }

            shifts(
                dateRange: $shiftsDateRange
            ) {
                ...shiftFragment

                assignments {
                    ...assignmentFragment
                    assignedTo {
                        # ...userProfileFragment
                        id
                        name
                        email
                    }
                    profession{
                        ...tagFragment
                    }
                }
            }

            draftShifts(
                dateRange: $shiftsDateRange
            ) {
                ...draftShiftFragment

                assignments {
                    ...draftAssignmentFragment
                    assignedTo {
                        # ...userProfileFragment
                        id
                        name
                        email
                    }
                    profession{
                        ...tagFragment
                    }
                }
            }


            created_by {
                # ...userProfileFragment
                id
                name
                email
            }
        }
    }
    ${projectSummaryFragment}
    ${tagFragment}
    ${customTagFragment}
    ${customTagLabelFragment}
    ${projectShiftFragment}
    ${shiftFragment}
    ${draftShiftFragment}
    ${projectAssignmentFragment}
    ${assignmentFragment}
    ${draftAssignmentFragment}
    ${resourceFragment}
    ${staffVehiculeFragment}
    ${resourceTypeFragment}
    ${categoryFragment}
`

export const SENDPARTNERPROJECTNOTIFICATIONS = gql`
    mutation sendPartnerProjectNotifications(
        $projectID: ID!
        $shiftsDateRange: activeDuringInputSingleDate!
    ){
        sendPartnerProjectNotifications(
            projectID: $projectID
        ){
            ...projectSummaryFragment
            prevShift(
                dateRange: $shiftsDateRange
            )
            nextShift(
                dateRange: $shiftsDateRange
            )

            professions{
                ...tagFragment
            }
            skills{
                ...tagFragment
            }
            courses{
                ...tagFragment
            }
            customtags{
                ...customTagFragment
                label{
                    ...customTagLabelFragment
                }
            }
            resources{
                ...resourceFragment
                type{
                    ...resourceTypeFragment
                }
            }

            projectManager{
                # ...userProfileFragment
                id
                name
                email
            }
            supervisor{
                # ...userProfileFragment
                id
                name
                email
            }
            customers{
                # ...customerFragment
                id
                name
            }
            projectCategories{
                ...categoryFragment
            }
            contacts {
                # ...customerContactFragment
                id
                name
                email
            }
            locations {
                # ...customerLocationFragment
                id
                name
            }

            projectShifts {
                ...projectShiftFragment
                courses{
                    ...tagFragment
                }
                skills{
                    ...tagFragment
                }
                customtags{
                    ...customTagFragment
                    label{
                        ...customTagLabelFragment
                    }
                }
                resources{
                    ...resourceFragment
                    type{
                        ...resourceTypeFragment
                    }
                }
                staffVehicules{
                    ...staffVehiculeFragment
                    type{
                        ...resourceTypeFragment
                    }
                }


                projectAssignments{
                    ...projectAssignmentFragment
                    assignedTo{
                        # ...userProfileFragment
                        id
                        name
                        email
                    }
                    profession{
                        ...tagFragment
                    }
                }
            }

            shifts(
                dateRange: $shiftsDateRange
            ) {
                ...shiftFragment

                assignments {
                    ...assignmentFragment
                    assignedTo {
                        # ...userProfileFragment
                        id
                        name
                        email
                    }
                    profession{
                        ...tagFragment
                    }
                }
            }

            draftShifts(
                dateRange: $shiftsDateRange
            ) {
                ...draftShiftFragment

                assignments {
                    ...draftAssignmentFragment
                    assignedTo {
                        # ...userProfileFragment
                        id
                        name
                        email
                    }
                    profession{
                        ...tagFragment
                    }
                }
            }


            created_by {
                # ...userProfileFragment
                id
                name
                email
            }
        }
    }
    ${projectSummaryFragment}
    ${tagFragment}
    ${customTagFragment}
    ${customTagLabelFragment}
    ${projectShiftFragment}
    ${shiftFragment}
    ${draftShiftFragment}
    ${projectAssignmentFragment}
    ${assignmentFragment}
    ${draftAssignmentFragment}
    ${resourceFragment}
    ${staffVehiculeFragment}
    ${resourceTypeFragment}
    ${categoryFragment}
`
    
    // ${userProfileFragment}
    // ${customerFragment}
    // ${customerContactFragment}
    // ${customerLocationFragment}
export const UPSERTPROJECT = gql`
    mutation upsertProject(
        $id: ID!
        $name: String
        $externalID: String
        $workforce_request_number: String
        $workforce_change_number: String
        $projectStatus: ProjectStatus
        $contract_number: String
        $description: String
        $start_date: Date
        $end_date: Date
        $internal_notes: String
        $tags: [ID]
        $projectShifts: projectShiftsRelationInput
        $projectManager: ID
        $disconnectProjectManager: Boolean
        $customers: [ID]
        $projectCategories: [ID]
        $contacts: [ID]
        $locations: [ID]
        $supervisor: ID
        $disconnectSupervisor: Boolean
        $shiftsDateRange: activeDuringInputSingleDate!
    ){
        upsertProject(
            input: {
                id: $id
                name: $name
                externalID: $externalID
                workforce_request_number: $workforce_request_number
                workforce_change_number: $workforce_change_number
                projectStatus: $projectStatus
                contract_number: $contract_number
                description: $description
                start_date: $start_date
                end_date: $end_date
                internal_notes: $internal_notes
                projectShifts: $projectShifts
                projectManager: { connect: $projectManager, disconnect: $disconnectProjectManager }
                tags: { connect: $tags }
                supervisor: { connect: $supervisor, disconnect: $disconnectSupervisor }
                customers: {sync: $customers}
                projectCategories: {sync: $projectCategories}
                contacts: {sync: $contacts}
                locations: {sync: $locations}
            }
        ){
            ...projectSummaryFragment
            hasUnpublishedShift
            prevShift(
                dateRange: $shiftsDateRange
            )
            nextShift(
                dateRange: $shiftsDateRange
            )
            professions{
                ...tagFragment
            }
            skills{
                ...tagFragment
            }
            courses{
                ...tagFragment
            }
            customtags{
                ...customTagFragment
                label{
                    ...customTagLabelFragment
                }
            }
            resources{
                ...resourceFragment
                type{
                    ...resourceTypeFragment
                }
            }

            projectManager{
                # ...userProfileFragment
                id
                name
                email
            }
            supervisor{
                # ...userProfileFragment
                id
                name
                email
            }
            customers{
                # ...customerFragment
                id
                name
            }
            projectCategories{
                ...categoryFragment
            }
            contacts {
                # ...customerContactFragment
                id
                name
                email
            }
            locations {
                # ...customerLocationFragment
                id
                name
            }

            projectShifts {
                ...projectShiftFragment
                courses{
                    ...tagFragment
                }
                skills{
                    ...tagFragment
                }
                customtags{
                    ...customTagFragment
                    label{
                        ...customTagLabelFragment
                    }
                }
                resources{
                    ...resourceFragment
                    type{
                        ...resourceTypeFragment
                    }
                }
                staffVehicules{
                    ...staffVehiculeFragment
                    type{
                        ...resourceTypeFragment
                    }
                }


                projectAssignments{
                    ...projectAssignmentFragment
                    assignedTo{
                        # ...userProfileFragment
                        id
                        name
                        email
                    }
                    profession{
                        ...tagFragment
                    }
                }
            }

            shifts(
                dateRange: $shiftsDateRange
            ) {
                ...shiftFragment

                assignments {
                    ...assignmentFragment
                    assignedTo {
                        # ...userProfileFragment
                        id
                        name
                        email
                    }
                    profession{
                        ...tagFragment
                    }
                }
            }

            draftShifts(
                dateRange: $shiftsDateRange
            ) {
                ...draftShiftFragment

                assignments {
                    ...draftAssignmentFragment
                    assignedTo {
                        # ...userProfileFragment
                        id
                        name
                        email
                    }
                    profession{
                        ...tagFragment
                    }
                }
            }

            created_by {
                # ...userProfileFragment
                id
                name
                email
            }
        }
    }
    ${projectSummaryFragment}
    ${tagFragment}
    ${customTagFragment}
    ${customTagLabelFragment}
    ${projectShiftFragment}
    ${shiftFragment}
    ${draftShiftFragment}
    ${projectAssignmentFragment}
    ${assignmentFragment}
    ${draftAssignmentFragment}
    ${resourceFragment}
    ${staffVehiculeFragment}
    ${resourceTypeFragment}
    ${categoryFragment}
`
    // ${userProfileFragment}
    // ${customerFragment}
    // ${customerContactFragment}
    // ${customerLocationFragment}

export const CREATEDRAFTSHIFTSDEBUG = gql`
    mutation createDraftShiftsV3(
        $projectID: ID!
        $shiftsDateRange: activeDuringInputSingleDate!
    ){
        createDraftShiftsV3(
            projectID: $projectID
        ){
            ...projectSummaryFragment
            hasUnpublishedShift
            
            prevShift(
                dateRange: $shiftsDateRange
            )
            nextShift(
                dateRange: $shiftsDateRange
            )

            professions{
                ...tagFragment
            }
            skills{
                ...tagFragment
            }
            courses{
                ...tagFragment
            }
            customtags{
                ...customTagFragment
                label{
                    ...customTagLabelFragment
                }
            }
            resources{
                ...resourceFragment
                type{
                    ...resourceTypeFragment
                }
            }

            projectManager{
                # ...userProfileFragment
                id
                name
                email
            }
            supervisor{
                # ...userProfileFragment
                id
                name
                email
            }
            customers{
                # ...customerFragment
                id
                name
            }
            projectCategories{
                ...categoryFragment
            }
            contacts {
                # ...customerContactFragment
                id
                name
                email
            }
            locations {
                # ...customerLocationFragment
                id
                name
            }

            projectShifts {
                ...projectShiftFragment
                courses{
                    ...tagFragment
                }
                skills{
                    ...tagFragment
                }
                customtags{
                    ...customTagFragment
                    label{
                        ...customTagLabelFragment
                    }
                }
                resources{
                    ...resourceFragment
                    type{
                        ...resourceTypeFragment
                    }
                }
                staffVehicules{
                    ...staffVehiculeFragment
                    type{
                        ...resourceTypeFragment
                    }
                }

                projectAssignments{
                    ...projectAssignmentFragment
                    assignedTo{
                        # ...userProfileFragment
                        id
                        name
                        email
                    }
                    profession{
                        ...tagFragment
                    }
                }
            }

            shifts(
                dateRange: $shiftsDateRange
            ) {
                ...shiftFragment

                assignments {
                    ...assignmentFragment
                    assignedTo {
                        # ...userProfileFragment
                        id
                        name
                        email
                    }
                    accepted_by {
                        # ...userProfileFragment
                        id
                        name
                        email
                    }
                    profession{
                        ...tagFragment
                    }
                }
            }

            draftShifts(
                dateRange: $shiftsDateRange
            ) {
                ...draftShiftFragment

                assignments {
                    ...draftAssignmentFragment
                    assignedTo {
                        # ...userProfileFragment
                        id
                        name
                        email
                    }
                    profession{
                        ...tagFragment
                    }
                }
            }


            created_by {
                # ...userProfileFragment
                id
                name
                email
            }
        }
    }
    ${projectSummaryFragment}
    ${tagFragment}
    ${customTagFragment}
    ${customTagLabelFragment}
    ${projectShiftFragment}
    ${shiftFragment}
    ${draftShiftFragment}
    ${projectAssignmentFragment}
    ${assignmentFragment}
    ${draftAssignmentFragment}
    ${resourceFragment}
    ${staffVehiculeFragment}
    ${resourceTypeFragment}
    ${categoryFragment}
`
    // ${userProfileFragment}
    // ${customerFragment}
    // ${customerContactFragment}
    // ${customerLocationFragment}